export const OfferUnsubscribeViewUat = {
  message: 'offerUnsubscribe.message',
  button: 'offerUnsubscribe.button',
}
